import React, { useContext } from 'react';
import { getStringFromReactNode } from '../../utils/get-string-from-react-node';
import s from './select.module.css';
import { context } from './utils';
const Section = ({ children }) => {
    const { native } = useContext(context);
    if (native) {
        return React.createElement("optgroup", { label: getStringFromReactNode(children) });
    }
    return React.createElement("div", { className: s.section }, children);
};
export default Section;
//# sourceMappingURL=section.js.map